import React from 'react'

function Icon() {
  return (
    <svg width="40" height="24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#fcecec" />
      <circle cx="12" cy="12" r="8" fill="none" stroke="#e14c4c" stroke-width="2" />
      <line x1="9" y1="15" x2="15" y2="9" stroke="#e14c4c" stroke-width="2" />
    </svg>
  )
}

export default Icon
